import { SeadevShedBuilder } from '../ssb_builder';
import { CANVAS_ATTRIBUTE_MAP } from './constants';
import { convertPricingData } from './utils';
import { SnapshotFormData } from './types';

/**
 * Reads current form/canvas/runner state from the DOM into a plain snapshot data object.
 *
 * @param shedBuilder - Builder instance containing the 3D/Fabric canvas reference.
 * @returns Raw snapshot form data object.
 */
export function collectFormData(shedBuilder: SeadevShedBuilder): SnapshotFormData {
	const canvas = shedBuilder._canvas;
	const getChecked = (s: string) => jQuery(`${s}:checked`);

	const roofPitchChecked = getChecked('input[name="ssb-configurator-upgrade-roof_pitch"]');
	let roofPitch: any = null;
	if (roofPitchChecked.length) {
		const roofPitchPriceCondition = roofPitchChecked.data('price-condition');
		roofPitch = [
			{
				ssb_configurator_default: true,
				ssb_configurator_name: roofPitchChecked.data('option-value'),
				ssb_configurator_value: roofPitchChecked.val(),
				ssb_configurator_condition_price: convertPricingData(roofPitchPriceCondition),
			},
		];
	}
	const canvasData: Record<string, string> = {};
	Object.keys(CANVAS_ATTRIBUTE_MAP).forEach((key) => {
		canvasData[key] = canvas ? canvas.getAttribute(CANVAS_ATTRIBUTE_MAP[key]) : '';
	});

	return {
		roof: { roofPitch },
		ssb_configurator_runner_color_setting: jQuery('#js-runner-use-default-color').data(
			'runner-use-default-color',
		),
		ssb_configurator_runner_custom_color:
			jQuery('#js-runner-custom-color').data('runner-custom-color'),
		ssb_configurator_runner_direction: jQuery('#js-runner-custom-direction').data(
			'runner-direction',
		),
		ssb_configurator_runner_enable_outer_joist: jQuery('#js-runner-enable-outer-joist').data(
			'runner-enable-outer-joist',
		),
		...canvasData,
	};
}
